'use es6';

import { combineReducers } from 'redux';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import * as ActionTypes from '../actions/ActionTypes';
import * as RequestKey from '../constants/RequestKey';
const requestStateFactory = (pendingActionType, succeededActionType, failedActionType, resetActionType) => {
  return (state = RequestState.UNINITIALIZED, action) => {
    switch (action.type) {
      case pendingActionType:
        return RequestState.PENDING;
      case succeededActionType:
        return RequestState.SUCCEEDED;
      case failedActionType:
        return RequestState.FAILED;
      case resetActionType:
        return RequestState.UNINITIALIZED;
      default:
        return state;
    }
  };
};
export default combineReducers({
  [RequestKey.APP_INTEGRATIONS]: requestStateFactory(ActionTypes.APP_INTEGRATIONS_REQUESTED, ActionTypes.APP_INTEGRATIONS_RECEIVED, ActionTypes.APP_INTEGRATIONS_FAILED),
  [RequestKey.ADMINS]: requestStateFactory(ActionTypes.ADMIN_FETCH_REQUESTED, ActionTypes.ADMIN_FETCH_RECEIVED, ActionTypes.ADMIN_FETCH_FAILED),
  [RequestKey.HUBS]: requestStateFactory(ActionTypes.HUB_FETCH_REQUESTED, ActionTypes.HUB_FETCH_RECEIVED, ActionTypes.HUB_FETCH_FAILED)
});